"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const uuid = require("uuid");
const base_url_1 = require("./base-url");
const logger_1 = require("./helpers/logger");
const nested_error_1 = require("./helpers/nested-error");
const COAM_TIMEOUT_IN_MS = 10000;
const COAM_CALL_TRIES_AMOUNT = 2;
const COAM_RESPONSE_WARNING_IN_MS = 1000;
async function readResourcePermissions(resourceIdentifier, resourceType, principal, authorization, correlationId) {
    return (await runCoamRequest(() => getResourceRequest(resourceIdentifier, resourceType, principal, authorization, correlationId), correlationId));
}
exports.readResourcePermissions = readResourcePermissions;
async function readResourceTypePermissions(resourceType, principal, authorization, correlationId) {
    return (await runCoamRequest(() => getResourceTypeRequest(resourceType, principal, authorization, correlationId), correlationId));
}
exports.readResourceTypePermissions = readResourceTypePermissions;
async function runCoamRequest(coamRequestGetter, correlationId, tries = COAM_CALL_TRIES_AMOUNT) {
    const start = Date.now();
    let err;
    for (let i = 0; i < tries; i++) {
        try {
            const response = await coamRequestGetter();
            const elapsedTime = Date.now() - start;
            if (elapsedTime > COAM_RESPONSE_WARNING_IN_MS) {
                logger_1.getLogger().warn({ correlationId }, `Coam request took ${elapsedTime}ms`);
            }
            return response.data;
        }
        catch (error) {
            err = new nested_error_1.NestedError('Unable to connect to COAM', error);
        }
        if (tries - i > 1) {
            await delay(1);
        }
    }
    throw err;
}
exports.runCoamRequest = runCoamRequest;
function getResourceTypeRequest(resourceType, principal, authorization, correlationId) {
    return getCoamRequest(`/principals/${principal}/permissions` +
        `/${resourceType}?cacheBust=${uuid()}`, authorization, correlationId);
}
function getResourceRequest(resourceIdentifier, resourceType, principal, authorization, correlationId) {
    return getCoamRequest(`/principals/${principal}/permissions` +
        `/${resourceType}/${resourceIdentifier}`, authorization, correlationId);
}
function getCoamRequest(uri, authorization, correlationId) {
    return axios_1.default.request({
        method: 'GET',
        url: `${base_url_1.getBaseUrl()}${uri}`,
        headers: {
            authorization,
            'x-request-id': correlationId,
        },
        timeout: COAM_TIMEOUT_IN_MS,
    });
}
function delay(seconds) {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}
//# sourceMappingURL=coam-proxy.js.map